import React from 'react';

export const NewDetailsImage = (props) => {
  return (
    <div>
      <img key={props.id} src={props.image} alt={props.image} />
    </div>
  );
};
